import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Text = props => {
  const { className, children, italic, bold } = props;
  const containerClassName = classnames('text', className, {
    'text--bold': bold,
    'text--italic': italic,
  });
  return <div className={containerClassName}>{children}</div>;
};

Text.propTypes = {
  bold: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  className: PropTypes.string,
  italic: PropTypes.bool,
};

export default Text;
